<template>
  <div>
    <b-row>
      <b-col cols="12">
        <membership-search-form
          @clicked="onSearchClick"
          @change="onSearchResult"
          :pagination="pagination"
        ></membership-search-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="6">
            <b-card>
              <div slot="header">
                <strong>Memberships</strong>
              </div>
              <transition name="slide">
                <pagination-table
                  :items="memberships"
                  :fields="[
                  {key: 'person', label: 'Full Name'},
                  {key: 'status'},
                  {key: 'type'},
                  {key: 'startAt', label: 'Start Date'},
                  {key: 'endAt', label: 'End Date'},
                  {key: 'cancelledAt', label: 'Cancelled Date'},
                  {key: 'actions', label: ''}
                ]"
                  :pagination="pagination"
                  :is-loading="isLoading"
                  item-url="membership/{id}"
                  @change="onPaginationChange"
                >
                </pagination-table>
              </transition>
            </b-card>
        </b-col>
      <b-col cols="12" lg="5">
          <flash-message transitionIn="animated swing"></flash-message>
          <b-card>
              <div slot="header">
                  <strong>Create Membership</strong>
              </div>
              <membership-form :add-option="true"></membership-form>
          </b-card>
      </b-col>
    </b-row>
  </div>
</template>


<script>

    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import {PaginationMeta} from "../../models/PaginationMeta";
    import PaginationTable from "../../components/base/PaginationTable";
    import MembershipForm from "../../components/membership/MembershipForm";
    import MembershipSearchForm from "../../components/membership/MembershipSearchForm";

    const MembershipRepo = RepositoryFactory.get('membership')

    export default {
        components: {
          MembershipSearchForm,
          MembershipForm,
          PaginationTable,
        },
        data (){
            return {
                memberships: [],
                errors: [],
                pagination: new PaginationMeta(),
                isLoading: true,
                searchParams: {},
            }
        },
        mounted () {
            MembershipRepo
                .get()
                .then(
                    response => (
                        this.memberships = response.data.data,
                        this.pagination  = response.data.meta,
                        this.isLoading   = false
                    )
                )
        },
        methods: {
            onSearchResult (response) {
                this.memberships = response.data,
                this.pagination  = response.meta,
                this.isLoading   = false
            },
            onSearchClick(params) {
                this.isLoading = true
                this.searchParams = params
            },
            onPaginationChange() {
              this.searchParams.page = this.pagination.page;
              this.searchParams.limit = this.pagination.limit;

              MembershipRepo
                .searchMembership(this.searchParams)
                .then(
                  response => (
                      this.items = response.data.data,
                      this.pagination = response.data.meta,
                      this.isLoading = false
                  )
                )
            },
        }
    }
</script>
